<template v-if="isPrincipal">
    <div class="container template-padding mt-2">
        <h3 class="bg-silver">Manning List</h3>
        <div class="row">
            <div class="col col-sm-12">
                <div class="box-container" v-if="mannings.length">
                    <div class="boxes" v-for="manning in mannings" :key="manning.id">
                        <div class="p-2 gradient-image-bg" style="height: 150px;">
                            <img :src="manningIcon(manning)" alt="icon" class="fit-img">
                        </div>
                        <div style="padding: 10px 0;">
                            <table id="dataSummary" class="table-hover text-small w-100">
                                <tbody>
                                <tr class="text-info">
                                    <td><i class="fas fa-users"></i></td>
                                    <td>Total Crew:</td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                        data-toggle="modal" data-target="#dashboardCrewModal"
                                        @click="viewManningCrew(manning, 'Total')"
                                      >
                                        {{ manning.crewCount }}
                                      </button>
                                    </td>
                                </tr>
                                <tr class="text-info">
                                    <td></td>
                                    <td>Onboard Crew:</td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                        data-toggle="modal" data-target="#dashboardCrewModal"
                                        @click="viewManningCrew(manning, 'Onboard')"
                                      >
                                        {{ manning.onboardCrewCount }}
                                      </button>
                                    </td>
                                </tr>
                                <tr class="text-info">
                                  <td></td>
                                  <td>Standby Crew:</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                      data-toggle="modal" data-target="#dashboardCrewModal"
                                      @click="viewManningCrew(manning, 'Standby')"
                                    >
                                      {{ manning.standbyCrewCount }}
                                    </button>
                                  </td>
                                </tr>

                                <!-- Stargate Manning can only see total, standby and onboard crew-->
                                <template v-if="notStargate">
                                <tr class="text-success">
                                    <td><i class="fas fa-syringe"></i></td>
                                    <td>Total Covid Vaccinated:</td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                              data-toggle="modal" data-target="#covidVaccinatedList" @click.prevent="viewCovidVaccinated(
                                                  {manning_id: manning.id, activity_code_id: ''}
                                              )">
                                        {{ manning.covidVaccinated }}
                                      </button>
                                    </td>
                                </tr>
                                <tr class="text-success">
                                  <td></td>
                                  <td>Onboard Vaccinated:</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                              data-toggle="modal" data-target="#covidVaccinatedList"
                                            @click.prevent="viewCovidVaccinated({manning_id: manning.id, activity_code_id: 2})">
                                        {{ manning.onboardCovidVaccinated }}
                                      </button>
                                  </td>
                                </tr>
                                <tr class="text-success">
                                  <td></td>
                                  <td>Standby Vaccinated:</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                              data-toggle="modal" data-target="#covidVaccinatedList"
                                            @click.prevent="viewCovidVaccinated({manning_id: manning.id, activity_code_id: 1})">
                                        {{ manning.standbyCovidVaccinated }}
                                      </button>
                                  </td>
                                </tr>
                                <tr class="text-success">
                                  <td></td>
                                  <td>Other Vaccinated:</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                              data-toggle="modal" data-target="#covidVaccinatedList"
                                            @click.prevent="viewCovidVaccinated({manning_id: manning.id, activity_code_id: 'others'})">
                                        {{ manning.otherVaccinated }}
                                    </button>
                                  </td>
                                </tr>
                                <tr class="text-danger">
                                    <td><i class="fas fa-notes-medical"></i></td>
                                    <td>Incident / Behav:</td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                              data-toggle="modal" data-target="#incidentList" @click.prevent="viewIncidentCrews(manning.id)">
                                        {{ manning.incidentCount }}
                                      </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td><i class="fas fa-file-medical"></i></td>
                                    <td>Medical Issues:</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                            data-toggle="modal" data-target="#medicalIssuesList" @click.prevent="viewMedialIssuesCrews(manning.id)">
                                      {{ manning.medIssuesCount }}
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td>Active P&I Case(s):</td>
                                  <td>
                                    <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                            data-toggle="modal" data-target="#pandiList" @click.prevent="viewPandICaseCrews(manning.id)">
                                      {{ manning.pandiCount }}
                                    </button>
                                  </td>
                                </tr>
                                <tr class="text-primary">
                                    <td><span class="fas fa-ship"></span></td>
                                    <td>Vessels:</td>
                                    <td>
                                      <button type="button" class="btn btn-sm btn-outline-primary border-0 font-weight-normal py-0"
                                              data-toggle="modal" :data-target="'#vesselList'+manning.code">
                                        {{ manning.vesselCount }}
                                      </button>
                                    </td>
                                </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="n in 6" :key="n" style="visibility: hidden;">
                                      <td></td>
                                      <td>1</td>
                                      <td>1</td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                            <button class="btn btn-sm btn-orange mt-2 px-3" data-backdrop='static' data-keyboard='false' data-toggle="modal" :data-target="'#manningFile'+manning.code">
                                Company Profile
                            </button>
                        </div>
                        <div style="height: 40px">
                            <button type="button" :class="`bg-company-${manning['company_id']} custom-button`"
                                    @click="setManning(manning.id)">
                                {{ manning.alias }}
                            </button>
                        </div>

                        <!-- Update Document Modal -->
                        <div class="modal fade w-100" :id="'manningFile'+manning.code" tabindex="-1" role="dialog"  aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div class="modal-content modal-lg">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Manning File</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>

                                    <!-- form -->
                                    <form>
                                        <div class="modal-body">
                                            <table class="table table-hover table-sm border-bottom table-bordered">
                                                <thead class="bg-lightgray">
                                                <tr>
                                                    <th class="border-0 text-small" scope="col">#</th>
                                                    <th class="border-0 text-small" scope="col">Document No.</th>
                                                    <th class="border-0 text-small" scope="col">Document Name</th>
                                                    <th class="border-0 text-small" scope="col">Date Issued</th>
                                                    <th class="border-0 text-small" scope="col">Date Expiry</th>
<!--                                                    <th class="border-0 text-small" scope="col">Created By</th>-->
<!--                                                    <th class="border-0 text-small" scope="col">Created At</th>-->
                                                    <th class="border-0 text-small" scope="col">Updated By</th>
                                                    <th class="border-0 text-small" scope="col">Updated At</th>
                                                    <th class="border-0 text-small" scope="col">Action</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(manningFile,index) in manning.files" :key="manningFile.id">
                                                    <th scope="row">{{index+1}}</th>
                                                    <th class="text-smaller" scope="row">{{manningFile.doc_no}}</th>
                                                    <td class="text-smaller">{{manningFile.doc_name}}</td>
                                                    <td class="text-smaller">{{manningFile.issued_date | moment('DD MMM YYYY') }}</td>
                                                    <td class="text-smaller">{{manningFile.expiry_date | moment('DD MMM YYYY') }}</td>
<!--                                                    <td class="text-smaller">{{manningFile.created_by || '' }}</td>-->
<!--                                                    <td class="text-smaller">{{manningFile.created_at | moment('DD MMM YYYY') }}</td>-->
                                                    <td class="text-smaller">{{manningFile.updated_by ? manningFile.updated_by : manningFile.created_by}}</td>
                                                    <td class="text-smaller">{{manningFile.updated_at | moment('DD MMM YYYY') }}</td>
                                                    <td class="text-smaller">
                                                        <button type="button" v-if="manningFile.hasFile" @click.prevent="view(manningFile.id)" class="btn btn-sm btn-xs btn-outline-info font-weight-bolder py-1 mr-1 ml-auto">
                                                            <span class="fas fa-eye"></span>
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="modal-footer"></div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <!-- Vessel List Modal -->
                        <div class="modal" data-backdrop="static"
                             tabindex="-1" aria-labelledby="vesselListTitle"
                             :id="'vesselList'+manning.code">
                          <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="h5 mb-0" id="vesselListTitle">{{ manning.alias }} VESSEL LIST </h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <div class="table-responsive my-2" style="height: 450px;">
                                  <table class="table table-hover table-bordered table-template-1 text-small table-striped sticky-header">
                                    <thead>
                                    <tr>
                                      <th>No</th>
                                      <th>Vessel Name</th>
                                      <th>Vessel Type</th>
                                    </tr>
                                    </thead>
                                    <tbody class="text-small">
                                    <tr class="ehover-custom" v-for="(vessel, index) in manning.vesselList" :key="vessel.vesselId" @click="viewVessel(vessel.vesselId)">
                                      <td class="text-center text-primary">{{ index + 1}}</td>
                                      <td class="text-center text-primary">{{vessel.vesselName}}</td>
                                      <td class="text-center text-primary">{{vessel.vesselType}}</td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <app-loading v-else></app-loading>
            </div>
        </div>

      <!-- P and I List Modal -->
      <div class="modal" data-backdrop="static"
           tabindex="-1" aria-labelledby="pandiListTitle"
           id="pandiList">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="h5 mb-0" id="pandiListTitle"> P & I Cases Crew List </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <template v-if="manningPnIs">
                <div class="row justify-content-between align-items-center">
                  <div class="col-auto">
                    <nav aria-label="...">
                      <ul class="pagination text-smallest mb-0 pb-0">
                        <li
                            class="page-item"
                            :class="{ disabled: pagination.currentPage === 1 }"
                        >
                          <button class="page-link" @click="pniSetPage(1)">First</button>
                        </li>

                        <li
                            v-for="page in paginationPages"
                            :key="page"
                            class="page-item"
                            :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
                        >
                          <button class="page-link" @click="pniSetPage(page)">
                            {{ page }}
                          </button>
                        </li>

                        <li
                            class="page-item"
                            :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
                        >
                          <button class="page-link" @click="pniSetPage(pagination.lastPage)">
                            Last
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="col-auto">
                    <small class="mx-3">{{
                        `${pagination.from} to ${pagination.to} of ${pagination.total}`
                      }}</small>
                  </div>
                </div>
                <div class="table-responsive my-2" style="height: 450px;">
                  <table class="table table-hover table-bordered table-template-1 text-small table-striped sticky-header">
                    <thead>
                    <tr>
                      <th>No</th>
                      <th>Crew IPN</th>
                      <th>Crew Name</th>
                      <th>Rank</th>
                      <th>Activity Code</th>
                    </tr>
                    </thead>
                    <tbody class="text-small">
                    <tr class="ehover-custom text-uppercase"
                        v-for="(pniCrew, index) in manningPnIs"
                        :key="pniCrew.index"
                        @click="viewCrewProfile(`${pniCrew.id}/issues/pni`)"
                    >
                      <td class="text-center text-primary"> {{ index + 1 }} </td>
                      <td class="text-center text-primary"> {{ pniCrew.ipn }} </td>
                      <td class="text-center text-primary"> {{ pniCrew.fullName }} </td>
                      <td class="text-center text-primary"> {{ pniCrew.rankAlias }} </td>
                      <td class="text-center text-primary"> {{ pniCrew.activityCode }} </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <app-loading v-else></app-loading>
            </div>
          </div>
        </div>
      </div>

      <DashboardCrewModal
          :manning="manningSelected"
          :crew-activity-status="crewActivityStatusSelected" />

      <!-- Medical Issues List Modal -->
      <div class="modal" data-backdrop="static"
           tabindex="-1" aria-labelledby="medicalIssuesListTitle"
           id="medicalIssuesList">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="h5 mb-0" id="medicalIssuesListTitle">Medical Issues Crew List </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <template v-if="manningMedIssues">
                <div class="row justify-content-between align-items-center">
                  <div class="col-auto">
                    <nav aria-label="...">
                      <ul class="pagination text-smallest mb-0 pb-0">
                        <li
                            class="page-item"
                            :class="{ disabled: pagination.currentPage === 1 }"
                        >
                          <button class="page-link" @click="medIssuesSetPage(1)">First</button>
                        </li>

                        <li
                            v-for="page in paginationPages"
                            :key="page"
                            class="page-item"
                            :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
                        >
                          <button class="page-link" @click="medIssuesSetPage(page)">
                            {{ page }}
                          </button>
                        </li>

                        <li
                            class="page-item"
                            :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
                        >
                          <button class="page-link" @click="medIssuesSetPage(pagination.lastPage)">
                            Last
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="col-auto">
                    <small class="mx-3">{{
                        `${pagination.from} to ${pagination.to} of ${pagination.total}`
                      }}</small>
                  </div>
                </div>
                <div class="table-responsive my-2" style="height: 450px;">
                  <table class="table table-hover table-bordered table-template-1 text-small table-striped sticky-header">
                    <thead>
                    <tr>
                      <th>No</th>
                      <th>Crew IPN</th>
                      <th>Crew Name</th>
                      <th>Rank</th>
                      <th>Activity Code</th>
                    </tr>
                    </thead>
                    <tbody class="text-small">
                    <tr class="ehover-custom text-uppercase"
                        v-for="(medIssueCrew, index) in manningMedIssues"
                        :key="medIssueCrew.index"
                        @click="viewCrewProfile(`${medIssueCrew.id}/issues/incident`)"
                    >
                      <td class="text-center text-primary"> {{ index + 1 }} </td>
                      <td class="text-center text-primary"> {{ medIssueCrew.ipn }} </td>
                      <td class="text-center text-primary"> {{ medIssueCrew.fullName }} </td>
                      <td class="text-center text-primary"> {{ medIssueCrew.rankAlias }} </td>
                      <td class="text-center text-primary"> {{ medIssueCrew.activityCode }} </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <app-loading v-else></app-loading>
            </div>
          </div>
        </div>
      </div>

      <!-- Incident/Behavioral List Modal -->
      <div class="modal" data-backdrop="static"
           tabindex="-1" aria-labelledby="incidentListTitle"
           id="incidentList">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="h5 mb-0" id="incidentListTitle"> Incident/Behavioral Crew List </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <template v-if="manningIncidents">
                <div class="row justify-content-between align-items-center">
                  <div class="col-auto">
                    <nav aria-label="...">
                      <ul class="pagination text-smallest mb-0 pb-0">
                        <li
                            class="page-item"
                            :class="{ disabled: pagination.currentPage === 1 }"
                        >
                          <button class="page-link" @click="incidentSetPage(1)">First</button>
                        </li>

                        <li
                            v-for="page in paginationPages"
                            :key="page"
                            class="page-item"
                            :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
                        >
                          <button class="page-link" @click="incidentSetPage(page)">
                            {{ page }}
                          </button>
                        </li>

                        <li
                            class="page-item"
                            :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
                        >
                          <button class="page-link" @click="incidentSetPage(pagination.lastPage)">
                            Last
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="col-auto">
                    <small class="mx-3">{{
                        `${pagination.from} to ${pagination.to} of ${pagination.total}`
                      }}</small>
                  </div>
                </div>
                <div class="table-responsive my-2" style="height: 450px;">
                  <table class="table table-hover table-bordered table-template-1 text-small table-striped sticky-header">
                    <thead>
                    <tr>
                      <th>No</th>
                      <th>Crew IPN</th>
                      <th>Crew Name</th>
                      <th>Rank</th>
                      <th>Activity Code</th>
                    </tr>
                    </thead>
                    <tbody class="text-small">
                    <tr class="ehover-custom text-uppercase"
                        v-for="(incidentCrew, index) in manningIncidents"
                        :key="incidentCrew.index"
                        @click="viewCrewProfile(`${incidentCrew.id}/behavior`)"
                    >
                      <td class="text-center text-primary"> {{ index + 1 }} </td>
                      <td class="text-center text-primary"> {{ incidentCrew.ipn }} </td>
                      <td class="text-center text-primary"> {{ incidentCrew.fullName }} </td>
                      <td class="text-center text-primary"> {{ incidentCrew.rankAlias }} </td>
                      <td class="text-center text-primary"> {{ incidentCrew.activityCode }} </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <app-loading v-else></app-loading>
            </div>
          </div>
        </div>
      </div>

      <admin-announcement-modal></admin-announcement-modal>

      <!-- Covid Vaccinated List Modal -->
      <div class="modal" data-backdrop="static"
           tabindex="-1" aria-labelledby="covidVaccinatedListTitle"
           id="covidVaccinatedList">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="h5 mb-0" id="covidVaccinatedListTitle"> Covid Vaccinated Crew List </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <template v-if="manningCovidVaccines">
                <div class="row justify-content-between align-items-center">
                  <div class="col-auto">
                    <nav aria-label="...">
                      <ul class="pagination text-smallest mb-0 pb-0">
                        <li
                            class="page-item"
                            :class="{ disabled: pagination.currentPage === 1 }"
                        >
                          <button class="page-link" @click="covidVaccinatedSetPage(1)">First</button>
                        </li>

                        <li
                            v-for="page in paginationPages"
                            :key="page"
                            class="page-item"
                            :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
                        >
                          <button class="page-link" @click="covidVaccinatedSetPage(page)">
                            {{ page }}
                          </button>
                        </li>

                        <li
                            class="page-item"
                            :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
                        >
                          <button class="page-link" @click="covidVaccinatedSetPage(pagination.lastPage)">
                            Last
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div v-if="pagination.total !== 0" class="col-auto text-small">
                    {{ `${pagination.from} to ${pagination.to} of ${pagination.total}`}}
                  </div>
                </div>
                <div class="table-responsive my-2" style="height: 450px;">
                  <table class="table table-hover table-bordered table-template-1 text-small table-striped sticky-header">
                    <thead>
                    <tr>
                      <th>No</th>
                      <th>Crew IPN</th>
                      <th>Crew Name</th>
                      <th>Rank</th>
                    </tr>
                    </thead>
                    <tbody class="text-small">
                    <tr class="ehover-custom text-uppercase"
                        v-for="(covVacCrew, index) in manningCovidVaccines"
                        :key="covVacCrew.index"
                        @click="viewCrewProfile(`${covVacCrew.id}/document/medical/covid-vaccine`)"
                    >
                      <td class="text-center text-primary">
                        {{ (pagination.perPage * (pagination.currentPage - 1)) +  (index + 1) }}
                      </td>
                      <td class="text-center text-primary"> {{ covVacCrew.ipn }} </td>
                      <td class="text-center text-primary"> {{ covVacCrew.fullName }} </td>
                      <td class="text-center text-primary"> {{ covVacCrew.rankAlias }} </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <app-loading v-else></app-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

  import { mapGetters, mapActions } from 'vuex';
  import { gateMixin } from '@/mixins/gateMixin';
  import { dataMixin } from '@/mixins/dataMixin';
  import $ from 'jquery'; // to alter bootstrap js

  import { vueAppMixin } from '@/mixins/vueAppMixin';
  import AppLoading from "@/components/elements/AppLoading";
  import {PREFIX} from "@/services/ConstantService";
  import router from "@/router";
  import AdminAnnouncementModal from "@/components/sub_components/dashboards/AdminAnnouncementModal";
  import DashboardCrewModal from "./modal/DashboardCrewModal.vue";

  export default {
    name: 'Principal',
    mixins: [ gateMixin, dataMixin, vueAppMixin ],

    components: {
      DashboardCrewModal,
      AppLoading,
      AdminAnnouncementModal
    },

    data(){
      return{
        isAddDocument: false,
        files:'',
        medIssuesParams: {
          manning_id: null,
          pandi: '',
          page: 0
        },
        incidentParams: {
          manning_id: null,
          page: 0
        },
        covidVaccinatedParams: {
          manning_id: null,
          activity_code_id: ''
        },
        manningSelected: null,
        crewActivityStatusSelected: null
      }
    },
    methods: {
      ...mapActions(['getMannings', 'setManningId','viewManningFile',
        'getManningMedIssues', 'getManningPandICases',
        'getManningIncidents', 'getManningCovidVaccines']),

      viewManningCrew(manning, crewActivityStatus) {
        this.manningSelected = manning
        this.crewActivityStatusSelected = crewActivityStatus
      },

      manningIcon(manning) {
        try {
          return require('@/assets/'+manning.id+'.png');
        } catch (error) {
          return require('@/assets/blank.png');
        }

      },

      setManning(manningId) {
        // this.setManningId(manningId);
          this.crewSearchParam.manning = manningId;
          this.crewSearchParam.searchValue = '';
        this.$router.push({name: 'CrewIndex'});
      },

      customFile(manningAlias) {
        var getFilePath = document.getElementById(manningAlias).value;
        var filename = getFilePath.replace(/^.*\\/, '');
        document.getElementById(manningAlias + '1').value = filename;
      },


      async view(id){
        await this.viewManningFile(id).then((response)=>{
          // console.log(this.pdfFile);
          if(response){
            const win = window.open('', '_blank');
            const pdf = this.pdfFile;
            const html = `
            <html>
              <title>Manning Document</title>
              <body style="margin:0!important;">
                <object width="100%" height="100%" data="data:application/pdf;base64,${pdf}" type="application/pdf"></object>
              </body>
            </html>`;
            win.document.write(html);
          }
        }).catch((e)=>{
          // console.log(e);
        });
      },

      viewVessel(vesselId) {
        $('.modal').modal('hide');
        this.$router.push({
          name: "VesselGeneralInfo",
          params: { id: vesselId },
        });
      },

      /** PNI modal methods */
      async viewPandICaseCrews(manningId = this.medIssuesParams.manning_id) {
        this.medIssuesParams.manning_id = manningId
        this.medIssuesParams.pandi = true
        this.medIssuesParams.page = this.pagination.currentPage
        await this.getManningPandICases(this.medIssuesParams)
      },
      async pniSetPage(page) {
        this.pagination.currentPage = page;
        await this.viewPandICaseCrews();
      },

      /** Medical Issues modal methods */
      async viewMedialIssuesCrews(manningId = this.medIssuesParams.manning_id) {
        this.medIssuesParams.manning_id = manningId
        this.medIssuesParams.pandi = ''
        this.medIssuesParams.page = this.pagination.currentPage
        await this.getManningMedIssues(this.medIssuesParams)
      },
      async medIssuesSetPage(page) {
        this.pagination.currentPage = page;
        await this.viewMedialIssuesCrews();
      },

      /** Incident modal methods */
      async viewIncidentCrews(manningId = this.incidentParams.manning_id) {
        this.incidentParams.manning_id = manningId
        this.incidentParams.page = this.pagination.currentPage
        await this.getManningIncidents(this.incidentParams)
      },
      async incidentSetPage(page) {
        this.pagination.currentPage = page;
        await this.viewIncidentCrews();
      },

      /** Covid Vaccinated modal methods */
      viewCovidVaccinated(params = this.covidVaccinatedParams) {
        this.covidVaccinatedParams.manning_id = params.manning_id
        this.covidVaccinatedParams.activity_code_id = params.activity_code_id
        this.covidVaccinatedParams.page = this.pagination.currentPage
        this.getManningCovidVaccines(params)
      },
      async covidVaccinatedSetPage(page) {
        this.pagination.currentPage = page;
        await this.viewCovidVaccinated(this.covidVaccinatedParams);
      },

      viewCrewProfile(crewRoute) {
        let routeData = this.$router.resolve({name: 'Crews'});
        window.open(routeData.href + `/index/${crewRoute}`, '_blank');
      },

      openAnnouncementModal () {
        let some = this.$route.params.announcementModalId;
        $(some).modal('show')
      },

    },

    computed: {
      ...mapGetters(['mannings','documents','manningDocument','pdfFile', 'crewSearchParam',
        'pagination', 'manningMedIssues', 'manningPnIs', 'manningIncidents', 'manningCovidVaccines',
      ]),

      paginationPages() {
        let pages = [];
        let currentPage = this.pagination.currentPage;
        let lastPage = this.pagination.lastPage;
        if (lastPage > 1) {
          let initialLimit = 1;
          if (currentPage + 5 > lastPage) {
            initialLimit = lastPage - 10;
          } else if (currentPage > 6) {
            initialLimit = currentPage - 5;
          }
          initialLimit = initialLimit < 1 ? 1 : initialLimit;
          for (let i = initialLimit; i <= initialLimit + 10; i++) {
            pages.push(i);
            if (i >= lastPage) {
              break;
            }
          }
        }
        return pages;
      },
    },

    created() {
        this.getMannings();
    },

    mounted() {
      this.openAnnouncementModal();
    }

  };
</script>

<style scoped>
    .fit-img {
        width: auto;
        height: 100%;
    }

    .box-container {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        box-sizing: border-box;
    }

    .boxes {
        width: 250px;
        /*height: 290px;*/
        /*height: 140px;*/
        margin: 10px;
        text-align: center;
        box-shadow: 0 0 3px #ccc;
        box-sizing: border-box;
    }

    #dataSummary {
        height: 100%;
    }

    #dataSummary tbody tr td:nth-child(2) {
        text-align: left;
    }

    #dataSummary tbody tr td {
        padding: 0 5px;
    }

    .custom-button {
        width: 100%;
        height: 100%;
        border: 0;
        outline: 0;
    }

    .custom-button:hover {
        opacity: 0.8;
    }

    .btn-orange {
        border: 2px solid orange;
        color: orange;
        border-radius: 2px;
        font-size: 12px;
        font-weight: bold;
    }

    .btn-orange:hover {
        background: orange;
        color: white;
    }

    div.fileinputs {
        position: relative;
        width: 180px;
        display: inline-block;
    }

    div.fakefile {
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        border: 1px solid #28a745;
        border-radius: 3px;
        color: #ffffff;
        background: #28a745;
        height: 25px;
        margin-top: 1px;
    }

    .fakefile input {
        width: 100px;
        border: none;
        background: #ffffff;
        height: 23px;
    }

    div.fileinputs input.file {
        position: relative;
        text-align: right;
        -moz-opacity: 0;
        filter: alpha(opacity:0);
        opacity: 0;
        z-index: 2;
    }
</style>

<style>
    .form-control-file,
    .form-control-range {
        display: block !important;
        width: 80% !important;
        height: 30% !important;
        font-size: 0.8em !important;
    }

    .multiselect__single{
        font-size: 0.9em !important;
    }

    .multiselect__element > span[data-select]{
        font-size: 0.8em !important;
    }

    .gradient-image-bg {
      background-image: url('~@/assets/Gradient1-01.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .ehover-custom {
      cursor: pointer;
    }
</style>
